import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { ExpandMore as ExpandMoreBase, GetApp as DownloadBase } from '@mui/icons-material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled(({ height, ...props }) => <div {...props} />)`
  height: ${props => props.height};
  width: 100%;
`

export const GridContainer = styled(
  ({ backgroundColor, borderTopLeftRadius, borderTopRightRadius, height, margin, maxWidth, padding, ...props }) => (
    <GridBase container {...props} />
  )
)`
  &.MuiGrid-container {
    background-color: ${props => props.backgroundColor};
    border-top-left-radius: ${props => props.borderTopLeftRadius};
    border-top-right-radius: ${props => props.borderTopRightRadius};
    height: ${props => props.height};
    margin: ${props => props.margin};
    max-width: ${props => props.maxWidth};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    text-align: ${props => props.textAlign};
  }
`

export const Jumbotron = styled('div')`
  background-color: ${props => props.theme.palette.brand.gray3};
  background-image: url('${props => props.source}');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: ${props => props.height};
  position: relative;
  width: 100%;
`

export const JumboContent = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 16px 16px 8px;
    position: relative;
    z-index: 2;
  }

  &.MuiContainer-root h1 {
    display: block;
    text-align: center;
    width: 100%;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 11px 38px 31px;
    }
  }
`

export const ErrorMessage = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  margin: 0 0 17px;
  max-width: 476px;
  text-align: center;
`

export const BreadcrumbsBackground = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  display: inline-block;
  padding: 5px 9px;
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  display: inline-block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 46px auto 0;
  max-width: 530px;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 68px auto 0;
  }
`

export const TitleBackground = styled('span')`
  background-color: ${props => props.theme.palette.brand.white};
  padding: 5px 9px;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    margin: -190px auto 0;
    position: relative;
  }
`

export const YearSelectorBackground = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  display: inline-flex;
  padding: 5px 4px;
`

export const Card = styled(CardBase)`
  &.MuiPaper-root > div {
    padding: 0;
  }
`

export const Info = styled('div')`
  align-items: center;
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
`

export const Datum = styled('div')`
  height: 100%;
  width: 100%;
`

export const Value = styled('div')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 26px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Label = styled(({ margin, ...props }) => <div {...props} />)`
  color: ${props => props.theme.palette.brand.black2};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  margin: ${props => props.margin};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Line = styled('div')`
  background-color: ${props => props.theme.palette.brand.gray1};
  height: 35px;
  margin: auto 30px auto 0;
  width: 1px;

  ${props => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const Action = styled(({ margin, ...props }) => <div {...props} />)`
  color: ${props => props.theme.palette.brand.black3};
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  margin: ${props => props.margin};

  &:hover {
    color: ${props => props.theme.palette.brand.black2};
  }
`

export const ActionLink = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: auto;
  justify-content: center;
  margin: 0 8px 0 0;

  &:hover > *,
  &:hover .MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.black2};
    fill: ${props => props.theme.palette.brand.black2};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    height: 20px;
  }
`

export const HelpIcon = styled('span')`
  box-sizing: border-box;
  color: ${props => props.theme.palette.brand.black3};
  font-size: 14px;
  font-weight: bold;
  border: 1px solid ${props => props.theme.palette.brand.black3};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 9px;
  margin-right: 8px;
  position: relative;
  top: -6px;

  ${props => props.theme.breakpoints.up('sm')} {
    top: 0;
  }
`

export const DownloadIcon = styled(DownloadBase)`
  &.MuiSvgIcon-root {
    box-sizing: border-box;
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 14px;
    border: 1px solid ${props => props.theme.palette.brand.black3};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`

export const Anchor = styled('div')`
  border-bottom: 2px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  pointer-events: none;
  margin: 0 16px 0 0;
  user-select: none;
`

export const AnchorIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black1};
    font-size: 24px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const TopDatum = styled('div')`
  cursor: default;
  color: ${props => props.theme.palette.brand.white};
`

export const Strong = styled('strong')``

export const Underline = styled('span')`
  text-decoration: underline;
`
